import { createInteractiveColorVar } from '../../helpers/createInteractiveColorVar/index.js';

const ControlPlaceholderColors = createInteractiveColorVar('controls-placeholder');
const ControlPlaceholderColorsLightValues = Object.freeze({
    default: '#707070',
    action: '#707070',
    active: '#707070',
    activeAction: '#707070',
});
const ControlPlaceholderColorsDarkValues = Object.freeze({
    default: '#7A7A7A',
    action: '#7A7A7A',
    active: '#7A7A7A',
    activeAction: '#7A7A7A',
});

export { ControlPlaceholderColors, ControlPlaceholderColorsDarkValues, ControlPlaceholderColorsLightValues };
